// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__osANX","large":"styles_large__3xTq4"};